export {
  listPages,
  getPageBySlugFromServer,
  getPageByTemplateFromServer,
  getPageByPathFromServer,
  listPagesByTemplateFromServer,
} from './services';
export { useListPages } from './hooks';
